import { GeometryUtils as G } from '../utils/Geometry.js';
export { OrbitConnector };
class OrbitConnector {
    static withFixedStartPoint({ startOrbit, startRotation, targetOrbit }) {
        const innerTangents = G.circlesInnerTangents(startOrbit.center, startOrbit.radius, targetOrbit.center, targetOrbit.radius), outerTangents = G.circlesOuterTangents(startOrbit.center, startOrbit.radius, targetOrbit.center, targetOrbit.radius);
        const tangents = [];
        if (innerTangents.length !== 0) {
            if (innerTangents[0] instanceof Array && innerTangents[1] instanceof Array) {
                tangents.push(OrbitConnector.regularTangentToConnectorTangent(innerTangents[0], startOrbit.center, targetOrbit.center));
                tangents.push(OrbitConnector.regularTangentToConnectorTangent(innerTangents[1], startOrbit.center, targetOrbit.center));
            }
            else {
                //TODO
            }
        }
        if (outerTangents.length !== 0) {
            if (outerTangents[0] instanceof Array && outerTangents[1] instanceof Array) {
                tangents.push(OrbitConnector.regularTangentToConnectorTangent(outerTangents[0], startOrbit.center, targetOrbit.center));
                tangents.push(OrbitConnector.regularTangentToConnectorTangent(outerTangents[1], startOrbit.center, targetOrbit.center));
            }
            else {
                //TODO
            }
        }
        const suitableTangents = tangents.filter(t => Math.sign(t.startRotation) === Math.sign(startRotation));
        return suitableTangents;
    }
    static withFixedStartAndEndPoint({ startOrbit, startRotation, targetOrbit, targetRotation }) {
        const tangents = OrbitConnector.withFixedStartPoint({ startOrbit, startRotation, targetOrbit });
        const suitableTangents = tangents.filter(t => Math.sign(t.endRotation) === Math.sign(targetRotation));
        return suitableTangents;
    }
    static regularTangentToConnectorTangent(tangent, centerA, centerB) {
        const direction = [tangent[1][0] - tangent[0][0], tangent[1][1] - tangent[0][1]];
        const vA = [tangent[0][0] - centerA[0], tangent[0][1] - centerA[1]];
        const vB = [tangent[1][0] - centerB[0], tangent[1][1] - centerB[1]];
        return {
            direction,
            startPoint: tangent[0],
            startRotation: G.rotation(vA, direction),
            endPoint: tangent[1],
            endRotation: G.rotation(vB, direction),
        };
    }
}
var OrbitConnectorResult;
(function (OrbitConnectorResult) {
    OrbitConnectorResult[OrbitConnectorResult["NO_TANGENTS"] = 0] = "NO_TANGENTS";
})(OrbitConnectorResult || (OrbitConnectorResult = {}));
//# sourceMappingURL=OrbitConnector.js.map